import { ICharacterVehicleOwnersHistory } from './backend/data/vehicles';
import { VehicleNumberPlate } from './vehicleNumberplates';

export interface IPlayerVehicleListItem {
	id: string;
	source: PlayerVehicleSource;
	vehicleNetId?: number;
	model: string;
	numberPlate: VehicleNumberPlate | null;

	isRegistered: boolean;
	isSpawned: boolean;
	isLocked: boolean;

	name: string;
	type: string;
	isFavorite: boolean;
}

export enum PlayerVehicleSource {
	Owned = 'owned',
	Job = 'job',
}

export enum VehicleClass {
	A = 'A',
	B = 'B',
	C = 'C',
	D = 'D',
	E = 'E',
}

export enum VehicleEngineType {
	Petrol = 'petrol',
	Electric = 'electric',
}

export enum VehicleFuelType {
	Petrol92 = 'petrol92',
	Petrol95 = 'petrol95',
	Petrol98 = 'petrol98',
	Petrol100 = 'petrol100',

	Electric220 = 'electric220',
	Electric380 = 'electric380',
	Electric500 = 'electric500',

	// Diesel1D,
	// Diesel2D,
}

// Максимальное количество флагов - 31
export enum VehicleStateFlag {
	Engine,
	TurnLightLeft,
	TurnLightRight,
	DoorOpenHood,
	DoorOpenTrunk,
	DoorOpenFL,
	DoorOpenFR,
	DoorOpenRL,
	DoorOpenRR,
	Headlights,
	Fullbeam,
}

export enum VehicleDoor {
	Hood,
	Trunk,
	FL,
	FR,
	RL,
	RR,
}

const doorToStateFlag: { [key in VehicleDoor]: VehicleStateFlag } = {
	[VehicleDoor.Hood]: VehicleStateFlag.DoorOpenHood,
	[VehicleDoor.Trunk]: VehicleStateFlag.DoorOpenTrunk,
	[VehicleDoor.FL]: VehicleStateFlag.DoorOpenFL,
	[VehicleDoor.FR]: VehicleStateFlag.DoorOpenFR,
	[VehicleDoor.RL]: VehicleStateFlag.DoorOpenRL,
	[VehicleDoor.RR]: VehicleStateFlag.DoorOpenRR,
};

for (const flag of Object.values(VehicleStateFlag)) {
	if (typeof flag === 'number' && flag > 30) {
		// Если возникает эта ошибка, стоит добавить еще одну переменную для хранения более 31 флаг.
		throw new Error('VehicleStateFlag limit exceeded. Bitmask can store only 31 values.');
	}
}

const engineFuelTypes: { [key in VehicleEngineType]: Set<VehicleFuelType> } = {
	[VehicleEngineType.Petrol]: new Set([
		VehicleFuelType.Petrol92,
		VehicleFuelType.Petrol95,
		VehicleFuelType.Petrol98,
		VehicleFuelType.Petrol100,
	]),
	[VehicleEngineType.Electric]: new Set([
		VehicleFuelType.Electric220,
		VehicleFuelType.Electric380,
		VehicleFuelType.Electric500,
	]),
};

const fuelTypeNames: { [key in VehicleFuelType]: string } = {
	[VehicleFuelType.Petrol92]: 'АИ 92',
	[VehicleFuelType.Petrol95]: 'АИ 95',
	[VehicleFuelType.Petrol98]: 'АИ 98',
	[VehicleFuelType.Petrol100]: 'АИ 100',

	[VehicleFuelType.Electric220]: '220W',
	[VehicleFuelType.Electric380]: '380W',
	[VehicleFuelType.Electric500]: '500W',
};

export function getVehicleStateFlagFromDoor(door: VehicleDoor): VehicleStateFlag {
	return doorToStateFlag[door];
}

export function getVehicleEngineFuelTypes(engineType: VehicleEngineType): VehicleFuelType[] {
	return Array.from(engineFuelTypes[engineType]);
}

export function isVehicleFuelTypeCompatible(engineType: VehicleEngineType, fuelType: VehicleFuelType): boolean {
	return engineFuelTypes[engineType].has(fuelType);
}

export function getVehicleFuelTypeName(fuelType: VehicleFuelType): string {
	return fuelTypeNames[fuelType];
}

export enum RageVehicleType {
	CAR = 'car',
	BUS = 'bus',
	TRUCK = 'truck',
	BIKE = 'bike',
	PLANE = 'plane',
	BICYCLE = 'bicycle',
	HELICOPTER = 'helicopter',
	BOAT = 'boat',
	QUADBIKE = 'quadbike',
	EMERGENCY_BOAT = 'emergency_boat',
}

export enum VehicleType {
	CAR = 'car',
	BIKE = 'bike',
}

export interface IVehiclePassportDetails {
	vinNumber: string;
	docNumber: string;
	duplicate: boolean;
}

export interface IVehicleLastOwnersHistory extends Pick<ICharacterVehicleOwnersHistory, 'mileage'> {
	ownerNickname: string;
	createdAt: string;
}

export interface IVehicleRegistrationDetails {
	modelName: string;
	bodyColor: string;
	vinNumber: string;
	bodyType: string;
	priceCash: number;
	mileage: number;
}

export interface IVehicleFuelDetails {
	engineType: VehicleEngineType;
	amount: number;
	capacity: number;
	bonus: number;
}
